module.exports = __webpack_public_path__ + "static/media/kocka3SD.20595f70.png";